"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.monolithEquipmentTypeArray = void 0;
const models_1 = require("./models");
exports.monolithEquipmentTypeArray = [
    models_1.EquipmentType.App,
    models_1.EquipmentType.Bike,
    models_1.EquipmentType.Elliptical,
    models_1.EquipmentType.Fusion,
    models_1.EquipmentType.InclineTrainer,
    models_1.EquipmentType.Rower,
    models_1.EquipmentType.Shoes,
    models_1.EquipmentType.StationaryBike,
    models_1.EquipmentType.Stepper,
    models_1.EquipmentType.Strength,
    models_1.EquipmentType.Strider,
    models_1.EquipmentType.StudioBike,
    models_1.EquipmentType.Treadmill,
    models_1.EquipmentType.TDFBike,
    models_1.EquipmentType.Wearable,
    models_1.EquipmentType.VibrationPlatform,
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9ub2xpdGguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzcmMvbW9ub2xpdGgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEscUNBQXlDO0FBRTVCLFFBQUEsMEJBQTBCLEdBQUc7SUFDeEMsc0JBQWEsQ0FBQyxHQUFHO0lBQ2pCLHNCQUFhLENBQUMsSUFBSTtJQUNsQixzQkFBYSxDQUFDLFVBQVU7SUFDeEIsc0JBQWEsQ0FBQyxNQUFNO0lBQ3BCLHNCQUFhLENBQUMsY0FBYztJQUM1QixzQkFBYSxDQUFDLEtBQUs7SUFDbkIsc0JBQWEsQ0FBQyxLQUFLO0lBQ25CLHNCQUFhLENBQUMsY0FBYztJQUM1QixzQkFBYSxDQUFDLE9BQU87SUFDckIsc0JBQWEsQ0FBQyxRQUFRO0lBQ3RCLHNCQUFhLENBQUMsT0FBTztJQUNyQixzQkFBYSxDQUFDLFVBQVU7SUFDeEIsc0JBQWEsQ0FBQyxTQUFTO0lBQ3ZCLHNCQUFhLENBQUMsT0FBTztJQUNyQixzQkFBYSxDQUFDLFFBQVE7SUFDdEIsc0JBQWEsQ0FBQyxpQkFBaUI7Q0FDaEMsQ0FBQyJ9